// GRUPOTECNICO requests
export const GRUPOTECNICO_LIST = "GRUPOTECNICO_LIST";
export const GRUPOTECNICO_FULLLIST = "GRUPOTECNICO_FULLLIST";
export const GRUPOTECNICO_LISTA = "GRUPOTECNICO_LISTA";
export const GRUPOTECNICO_CREATE = "GRUPOTECNICO_CREATE";
export const GRUPOTECNICO_FILTER = "GRUPOTECNICO_FILTER";
export const GRUPOTECNICO_UPDATE = "GRUPOTECNICO_UPDATE";
export const GRUPOTECNICO_DELETE = "GRUPOTECNICO_DELETE";
export const GRUPOTECNICO_READ = "GRUPOTECNICO_READ";

// GRUPOTECNICO success
export const GRUPOTECNICO_LIST_SUCCESS = "GRUPOTECNICO_LIST_SUCCESS";
export const GRUPOTECNICO_FULLLIST_SUCCESS = "GRUPOTECNICO_FULLLIST_SUCCESS";
export const GRUPOTECNICO_CREATE_SUCCESS = "GRUPOTECNICO_CREATE_SUCCESS";
export const GRUPOTECNICO_UPDATE_SUCCESS = "GRUPOTECNICO_UPDATE_SUCCESS";
export const GRUPOTECNICO_DELETE_SUCCESS = "GRUPOTECNICO_DELETE_SUCCESS";
export const GRUPOTECNICO_READ_SUCCESS = "GRUPOTECNICO_READ_SUCCESS";

// GRUPOTECNICO failed
export const GRUPOTECNICO_REQUEST_FAILED = "GRUPOTECNICO_REQUEST_FAILED";
